import { useKeycloak } from "@react-keycloak/web";
import { DashboardFilters } from "../components/DashboardFilters";
import { MapPage } from "../components/Map";


import { useProjectsPage, useProjectsStore } from "../state/projects";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";

export const DashboardPage = (
  { showMenu, setShowMenu, mapReload }:
    { showMenu: boolean, setShowMenu?: React.Dispatch<React.SetStateAction<boolean>>, mapReload?: boolean }
) => {
  const { keycloak: { token } } = useKeycloak();
  const { loadProjectsPage } = useProjectsPage();
  const projectsData = useProjectsStore((state) => state.projects);
  const [riskLevelFilter, setRiskLevelFilter] = useState<string>('all');
  const [viewMode, setViewMode] = useState<'map' | 'projects'>('map');

  useEffect(() => {
    async function loadProjects() {
      try {
        await loadProjectsPage(1);
      } catch (error) {
        toast.error('Failed to load projects', {
          toastId: 'failed-to-load-projects'
        });
        console.error(error);
      }
    }
    if (token) {
      loadProjects();
    }
  }, [token]);





  const handleRiskLevelFilter = (riskLevel: string) => {
    setRiskLevelFilter(riskLevel);
  };


  
  return (
    <div className="relative w-full h-screen">
      {!mapReload && (
        <div className="absolute inset-0 z-0">
          {viewMode === 'map' ? (
            <MapPage servers={projectsData || []} showMenu={showMenu} riskFilter={riskLevelFilter} />
          ) : (
            // List view should redirect to projects page, not show "Coming soon"
            // This case should not happen since List view navigates to /projects
            <div className="w-full h-full bg-gray-100 flex items-center justify-center">
              <div className="text-center">
                <div className="text-gray-500 text-lg mb-2">Redirecting to Projects...</div>
              </div>
            </div>
          )}
        </div>
      )}
      
      {/* Dashboard Filters - show for map and projects views */}
      {(viewMode === 'map' || viewMode === 'projects') && (
        <div className="relative z-10">
          <DashboardFilters
            setShowMenu={setShowMenu}
            showMenu={showMenu}
            view={viewMode}
            onViewChange={setViewMode}
            onPriorityFilter={handleRiskLevelFilter}
            selectedRiskLevel={riskLevelFilter}
          />
        </div>
      )}
    </div>
  );
};
